export const WORKBENCH_TABSETS = { dataSources: ['connections', 'agents'] };
export const WORKBENCH_SCHEMA_VERSION = 2;
